import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';

interface Props {
  actionVerb: string;
  resource: string;
  onClose: () => void;
}

function MissingPermissionDialog({ actionVerb, resource, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <AlertDialog
      header={{
        title: t('Common:MissingPermissions'),
        description: t('Common:YouDontHavePermissionAskOwner', {
          action: actionVerb,
          subject: resource,
        }),
      }}
      primaryAction={{ label: t('Common:GotIt'), onClick: onClose }}
      secondaryAction="hidden"
      onClose={onClose}
    />
  );
}

export default MissingPermissionDialog;
